module.exports = __webpack_public_path__ + "static/media/icon-carregamento.5c49a961.svg";